/**
 * The Fully Loaded Jumper
 * File: assets/free-upgrade.js
 * Loaded only by layout/free-upgrade.liquid.
 * Handles: option picking, live prices, gallery, countdown, sticky bar,
 * one-tap add to cart then /checkout (UTMs, cart attributes, location events), reviews modal, guarantee popover.
 * Config comes from #fu-config in sections/free-upgrade-hero.liquid. Prices are cents.
 */

(function () {
  'use strict';

  var configEl = document.getElementById('fu-config');
  if (!configEl) return;
  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (err) {
    console.warn('[Fully Loaded] Could not read #fu-config.', err);
    return;
  }

  var root = document.documentElement;
  var form = document.getElementById('fu-form');
  var idInput = form && form.querySelector('[data-fu-variant-input]');
  var endAt = Date.parse(cfg.end);
  var forced = root.hasAttribute('data-fu-forced');

  var variants = Object.keys(cfg.variants).map(function (id) {
    var v = cfg.variants[id];
    return { id: id, o: v.o, price: v.p, offer: v.x, available: v.a, qty: v.q };
  });

  /* ═══ MONEY ═══ */
  /* Plain "$199.99" to match snippets/fu-price.liquid. whole=true drops ".00" ($20). */
  function formatMoney(cents, whole) {
    var parts = (cents / 100).toFixed(2).split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (whole && parts[1] === '00') return '$' + dollars;
    return '$' + dollars + '.' + parts[1];
  }

  /* ═══ VARIANTS ═══ */
  function findVariant(o) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.o[0] === o[0] && v.o[1] === o[1] && v.o[2] === o[2]) return v;
    }
    return null;
  }

  function matching(match) {
    return variants.filter(function (v) {
      return v.available && match.every(function (val, i) { return val == null || v.o[i] === val; });
    });
  }
  function anyAvailable(match) { return matching(match).length > 0; }

  var initial = variants.filter(function (v) { return idInput && v.id === idInput.value; })[0] || variants[0];
  var sel = initial.o.slice();

  /* Offer difference between Large and Regular, for the Large pill and the FAQ. */
  var sizeup = (function () {
    var reg = variants.filter(function (v) { return v.o[1] === 'Regular' && v.offer != null; })[0];
    var lg = variants.filter(function (v) { return v.o[1] === 'Large' && v.offer != null; })[0];
    return reg && lg && lg.offer > reg.offer ? lg.offer - reg.offer : null;
  })();

  function prices(v) {
    var color = sel[0], size = sel[1], kitColor = sel[2];
    var jumper = cfg.jumper[color + '|' + size];
    var bundle = cfg.bundle[color + '|' + size];
    var kit = cfg.kit[kitColor];
    var kitPrice = kit ? kit.p : null;
    return {
      list: v ? v.price : null,
      offer: v && v.offer != null ? v.offer : null,
      keep: v && v.offer != null ? v.price - v.offer : null,
      jumper: jumper ? jumper.p : null,
      insert: cfg.insert,
      rain: cfg.rain[size] != null ? cfg.rain[size] : null,
      kit: kitPrice,
      tomorrow: bundle != null && kitPrice != null ? bundle + kitPrice : null,
      sizeup: sizeup
    };
  }

  function swapImage(img, data, alt) {
    if (!img || !data || img.getAttribute('src') === data.src) return;
    img.srcset = data.srcset;
    img.src = data.src;
    if (alt != null) img.alt = alt;
  }

  /* ═══ RENDER ═══ */
  var lastColor = sel[0];

  function render() {
    var v = findVariant(sel);

    document.querySelectorAll('[data-fu-opt]').forEach(function (input) {
      var idx = Number(input.getAttribute('data-fu-opt'));
      var value = input.value;
      input.checked = sel[idx] === value;
      if (idx === 0) {
        /* Colors: only those in stock for the selected size. Sold out = disabled. */
        var ok = anyAvailable([value, sel[1], null]);
        input.disabled = !ok;
        var label = input.closest('label').querySelector('[data-fu-soldout-label]');
        if (label) label.hidden = ok;
      } else if (idx === 1) {
        input.disabled = !anyAvailable([null, value, null]);
      } else {
        /* Sold-out Photo Kit colors are hidden, same as the Liquid skip. */
        input.closest('label').hidden = !anyAvailable([sel[0], sel[1], value]) && !input.checked;
      }
    });

    var sizeNote = document.querySelector('[data-fu-size-note]');
    if (sizeNote) sizeNote.hidden = sel[1] !== 'Large';

    document.querySelectorAll('[data-fu-selected]').forEach(function (el) {
      el.textContent = sel[Number(el.getAttribute('data-fu-selected'))];
    });

    if (v && idInput) {
      idInput.value = v.id;
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== v.id) {
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    var p = prices(v);
    document.querySelectorAll('[data-fu-price]').forEach(function (el) {
      var key = el.getAttribute('data-fu-price');
      var val = p[key];
      el.textContent = val != null ? formatMoney(val, key === 'sizeup') : '';
    });
    document.querySelectorAll('[data-fu-need]').forEach(function (el) {
      el.hidden = p[el.getAttribute('data-fu-need')] == null;
    });

    /* No offer price: never sell at list. Hide every buy button. */
    if (!v || v.offer == null) {
      root.setAttribute('data-fu-nooffer', '');
      console.warn('[Fully Loaded] ' + (v ? 'Variant ' + v.id + ' (' + v.o.join(' / ') + ')' : 'Selected combination') + ' has no custom.offer_price. Buy buttons hidden.');
    } else {
      root.removeAttribute('data-fu-nooffer');
    }
    if (v && !v.available) root.setAttribute('data-fu-soldout', '');
    else root.removeAttribute('data-fu-soldout');

    /* Low stock: only at or below the threshold, from live inventory. */
    var low = document.querySelector('[data-fu-lowstock]');
    if (low) {
      var showLow = v && v.available && v.qty != null && v.qty <= cfg.lowStockAt;
      low.hidden = !showLow;
      if (showLow) low.textContent = cfg.lowStockText.replace('[qty]', v.qty).replace('[color]', sel[0]);
    }

    /* Images: every Jumper image follows the color. The stack thumb follows the Photo Kit color. */
    var jumper = cfg.jumper[sel[0] + '|' + sel[1]];
    if (jumper && jumper.img) {
      var alt = (cfg.altTemplate || '').replace('[color]', sel[0]);
      document.querySelectorAll('[data-fu-jumper-img] img').forEach(function (img) {
        swapImage(img, jumper.img, img.alt === '' ? '' : alt);
      });
    }
    var kit = cfg.kit[sel[2]];
    if (kit && kit.img) {
      document.querySelectorAll('[data-fu-kit-img] img').forEach(function (img) { swapImage(img, kit.img, ''); });
    }

    if (sel[0] !== lastColor) {
      lastColor = sel[0];
      showJumperSlide();
    }
  }

  function bestColorFor(size) {
    var totals = {};
    matching([null, size, null]).forEach(function (v) { totals[v.o[0]] = (totals[v.o[0]] || 0) + (v.qty || 0); });
    return Object.keys(totals).sort(function (a, b) { return totals[b] - totals[a]; })[0];
  }

  function onOptionChange(e) {
    var input = e.target.closest('[data-fu-opt]');
    if (!input) return;
    var idx = Number(input.getAttribute('data-fu-opt'));
    sel[idx] = input.value;

    /* Large only comes in some colors: move to the best-stocked one that fits. */
    if (!anyAvailable([sel[0], sel[1], null])) {
      var color = bestColorFor(sel[1]);
      if (color) sel[0] = color;
    }
    if (!anyAvailable([sel[0], sel[1], sel[2]])) {
      var fallback = matching([sel[0], sel[1], 'Nimbus Gray'])[0] || matching([sel[0], sel[1], null])[0];
      if (fallback) sel[2] = fallback.o[2];
    }
    render();
  }
  document.addEventListener('change', onOptionChange);

  var kitToggle = document.querySelector('[data-fu-kit-toggle]');
  if (kitToggle) {
    kitToggle.addEventListener('click', function () {
      var set = document.getElementById(kitToggle.getAttribute('aria-controls'));
      var open = kitToggle.getAttribute('aria-expanded') !== 'true';
      kitToggle.setAttribute('aria-expanded', String(open));
      if (set) set.hidden = !open;
    });
  }

  /* ═══ GALLERY ═══ */
  var track = document.querySelector('[data-fu-gallery-track]');
  var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.fu-gallery__slide:not(.fu-todo)')) : [];
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-fu-thumb]'));
  var indexEl = document.querySelector('[data-fu-gallery-index]');

  function markSlide(i) {
    if (indexEl) indexEl.textContent = String(i + 1);
    thumbs.forEach(function (t, n) {
      if (n === i) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  }
  function goTo(i, smooth) {
    if (!track || !slides[i]) return;
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    markSlide(i);
  }
  function showJumperSlide() {
    var i = slides.findIndex(function (s) { return s.hasAttribute('data-fu-jumper-img'); });
    if (i > -1) goTo(i, true);
  }
  if (track) {
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        markSlide(Math.round(track.scrollLeft / track.clientWidth));
      }, 60);
    }, { passive: true });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-fu-thumb')) - 1, true); });
  });

  /* ═══ COUNTDOWN ═══ */
  var cdSr = document.querySelector('[data-fu-cd-sr]');
  var lastSrMinute = null;
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var now = Date.now();
    if (!forced) {
      var state = now > endAt ? 'after' : 'live';
      if (root.getAttribute('data-fu-state') !== state) root.setAttribute('data-fu-state', state);
    }
    var left = Math.max(0, endAt - now);
    var h = Math.floor(left / 3600000);
    var m = Math.floor((left % 3600000) / 60000);
    var s = Math.floor((left % 60000) / 1000);
    document.querySelectorAll('[data-fu-cd="h"]').forEach(function (el) { el.textContent = pad(h); });
    document.querySelectorAll('[data-fu-cd="m"]').forEach(function (el) { el.textContent = pad(m); });
    document.querySelectorAll('[data-fu-cd="s"]').forEach(function (el) { el.textContent = pad(s); });
    var totalMin = Math.floor(left / 60000);
    if (cdSr && totalMin !== lastSrMinute) {
      lastSrMinute = totalMin;
      cdSr.textContent = 'Ends in ' + h + (h === 1 ? ' hour ' : ' hours ') + m + (m === 1 ? ' minute.' : ' minutes.');
    }
  }

  /* "(9:00pm your time)": midnight ET in the visitor's zone. Hidden for visitors already on Eastern time. */
  (function localEndTime() {
    var el = document.querySelector('[data-fu-localtime]');
    if (!el || !window.Intl) return;
    try {
      var midnight = new Date(endAt + 1000);
      var opts = { hour: 'numeric', minute: '2-digit' };
      var local = new Intl.DateTimeFormat('en-US', opts).format(midnight);
      var eastern = new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: 'America/New_York' }, opts)).format(midnight);
      if (local === eastern) return;
      el.textContent = '(' + local.replace(/\s/g, '').toLowerCase() + ' your time)';
      el.hidden = false;
    } catch (err) { /* leave hidden */ }
  })();

  /* ═══ STICKY BAR ═══
     Visible whenever neither the buy button nor the express checkout buttons are on screen,
     so it can never sit on top of them. */
  var sticky = document.querySelector('[data-fu-sticky]');
  var heroCta = document.querySelector('[data-fu-cta]');
  var express = document.querySelector('[data-fu-express]');
  if (sticky && heroCta && 'IntersectionObserver' in window) {
    var seen = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { seen.set(entry.target, entry.isIntersecting); });
      var anyVisible = false;
      seen.forEach(function (v) { if (v) anyVisible = true; });
      sticky.classList.toggle('is-hidden', anyVisible);
    });
    io.observe(heroCta);
    if (express) io.observe(express);
  } else if (sticky) {
    sticky.classList.remove('is-hidden');
  }

  /* ═══ UTMs ═══ Kept from the SMS link through to checkout. */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
  var utm = {};
  (function () {
    var params = new URLSearchParams(location.search);
    UTM_KEYS.forEach(function (k) { if (params.get(k)) utm[k] = params.get(k); });
    try {
      if (Object.keys(utm).length) sessionStorage.setItem('fu_utm', JSON.stringify(utm));
      else utm = JSON.parse(sessionStorage.getItem('fu_utm') || '{}');
    } catch (err) { /* storage blocked: use what is in the URL */ }
  })();
  function checkoutUrl() {
    var qs = new URLSearchParams(utm).toString();
    return '/checkout' + (qs ? '?' + qs : '');
  }

  /* ═══ ANALYTICS ═══
     The theme's existing tracking (GTM, Elevar, Shopify pixels) already sends the standard GA4 add_to_cart
     and Meta AddToCart on every add. Sending them again here double-counts, so the button location goes
     out as its own event instead: GA4 add_to_cart_location, Meta AddToCartLocation (custom), and dataLayer. */
  function trackAddToCart(v, location) {
    var value = v && v.offer != null ? v.offer / 100 : null;
    var variantId = v ? v.id : '';
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'add_to_cart_location', { cta_location: location, value: value, currency: 'USD', variant_id: variantId, transport_type: 'beacon' });
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'fu_add_to_cart', cta_location: location, value: value, currency: 'USD', variant_id: variantId });
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'AddToCartLocation', { cta_location: location, value: value, currency: 'USD', content_ids: [variantId] });
      }
    } catch (err) {
      console.warn('[Fully Loaded] Analytics call failed.', err);
    }
  }

  /* UTMs and the button location go on the cart as attributes, so every order records them. */
  function saveAttributes(location) {
    var attrs = { fu_cta_location: location };
    Object.keys(utm).forEach(function (k) { attrs[k] = utm[k]; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () { /* never block checkout on this */ });
  }

  /* ═══ ONE-TAP CHECKOUT ═══
     Capture on window runs before theme or app submit handlers (cart drawers, upsell popups),
     so the shopper goes straight to /checkout. Without JS the form's return_to does the same. */
  var busy = false;
  var errorEl = document.querySelector('[data-fu-error]');

  function setBusy(on) {
    busy = on;
    document.querySelectorAll('[data-cta-location]').forEach(function (b) {
      b.disabled = on;
      b.setAttribute('aria-busy', String(on));
    });
  }

  window.addEventListener('submit', function (e) {
    if (!form || e.target !== form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    if (root.getAttribute('data-fu-state') !== 'live' || root.hasAttribute('data-fu-nooffer') || root.hasAttribute('data-fu-soldout')) return;

    var location = (e.submitter && e.submitter.getAttribute('data-cta-location')) || 'buybox';
    var v = findVariant(sel);
    setBusy(true);
    if (errorEl) errorEl.hidden = true;

    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    var body = new FormData(form);
    body.delete('return_to');

    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data && (r.data.description || r.data.message) || 'Could not add to cart.');
        trackAddToCart(v, location);
        /* Attributes first (capped at 1.5s), and at least 250ms so the analytics beacons leave. */
        var go = function () { window.location.assign(checkoutUrl()); };
        var timeout = new Promise(function (r) { setTimeout(r, 1500); });
        var minWait = new Promise(function (r) { setTimeout(r, 250); });
        Promise.all([Promise.race([saveAttributes(location), timeout]), minWait]).then(go, go);
      })
      .catch(function (err) {
        setBusy(false);
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          errorEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
  }, true);

  /* Back button from checkout restores the page from bfcache with buttons still disabled. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) setBusy(false);
  });

  /* ═══ IN-PAGE LINKS ═══ Smooth scroll, no hash jump. */
  document.querySelectorAll('[data-fu-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ═══ GUARANTEE POPOVER ═══ */
  document.querySelectorAll('[data-fu-pop]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    function set(open) {
      btn.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      set(btn.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target)) set(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { set(false); btn.focus(); }
    });
  });

  /* ═══ REVIEWS MODAL ═══ Moves the Junip apps section into a dialog. Never leaves the page. */
  var reviewsOpen = document.querySelector('[data-fu-reviews-open]');
  var dialog = document.querySelector('[data-fu-reviews-dialog]');
  var reviewsSection = document.querySelector('[id^="shopify-section-"][id$="__fu_reviews"]');
  if (reviewsOpen && dialog && reviewsSection && typeof dialog.showModal === 'function') {
    reviewsOpen.hidden = false;
    var modalBody = dialog.querySelector('[data-fu-reviews-body]');
    reviewsOpen.addEventListener('click', function () {
      if (reviewsSection.parentElement !== modalBody) {
        modalBody.appendChild(reviewsSection);
        reviewsSection.classList.add('fu-reviews-in-modal');
      }
      dialog.showModal();
    });
    dialog.querySelector('[data-fu-reviews-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  /* ═══ FLOATING WIDGET GUARD ═══
     App widgets like "Build Your Kit" or a TikTok sticker are hidden on this template. Matches by text,
     only on fixed elements outside this page's own markup. */
  var FLOAT_TEXT = /build your kit|viral tiktok|tiktok backpack/i;
  function hideFloats() {
    document.querySelectorAll('body > *:not(main):not(script):not(dialog)').forEach(function (el) {
      if (el.closest('.fu') || el.hasAttribute('data-fu-hidden-float')) return;
      var nodes = [el].concat(Array.prototype.slice.call(el.querySelectorAll('*'), 0, 200));
      nodes.some(function (node) {
        var pos = getComputedStyle(node).position;
        if ((pos === 'fixed' || pos === 'sticky') && FLOAT_TEXT.test(node.textContent + ' ' + (node.getAttribute('aria-label') || ''))) {
          node.setAttribute('data-fu-hidden-float', '');
          return true;
        }
        return false;
      });
    });
  }
  window.addEventListener('load', function () {
    hideFloats();
    setTimeout(hideFloats, 2500);
    setTimeout(hideFloats, 6000);
  });

  /* ═══ INIT ═══ */
  render();
  tick();
  setInterval(tick, 1000);
})();
